<div class="container-account">
  <!-- <h4>Sua conta</h4> -->

  <!-- GRID PRINCIPAL -->
  <div class="grid" *ngIf="list === 0">
    <!-- CARD MEUS DADOS -->
    <div class="card card-dados">
      <h5>Meus dados</h5>
      <p>Visualize seus dados e informações da conta.</p>
      <!-- <p><b>Código:</b> {{ initProvider.usuario?.id }}</p>
      <p><b>Nome:</b> {{ initProvider.usuario?.nome }}</p>
      <p><b>Login:</b> {{ initProvider.usuario?.login }}</p> -->
      <button class="btn-primary mt-auto" (click)="goTo(2)">Visualizar</button>
    </div>

    <!-- CARD BOLETOS -->
    <div class="card card-boletos">
      <h5>Meus boletos</h5>
      <p>Visualize e baixe seus boletos.</p>
      <button class="btn-primary mt-auto" (click)="
      goTo(1);
      getBoletos(1)
      ">Acessar</button>
    </div>

    <!-- CARD ALTERAR SENHA -->
    <div class="card card-senha">
      <h5>Alterar senha</h5>
      <p>Atualize sua senha de acesso.</p>
      <button class="btn-primary mt-auto" (click)="goTo(3)">Alterar</button>
    </div>
    <div class="card card-pedidos">
      <h5>Pedidos</h5>
      <p>Visualize seus pedidos.</p>
      <button class="btn-primary mt-auto" routerLink="/pedidos">
        Visualizar
      </button>
    </div>

    <div class="card card-pedidos">
      <h5>Pedidos ERP</h5>
      <p>Visualize seus pedidos no ERP.</p>
      <button class="btn-primary mt-auto" (click)="
      goTo(4);
     getPedidoErp()
      ">
        Visualizar
      </button>
    </div>
    <div class="card card-pedidos">
      <h5>Notas</h5>
      <p>Visualize suas notas fiscais.</p>
      <button class="btn-primary mt-auto" (click)="
      goTo(5);
      getPedidoNotas()
      ">
        Visualizar
      </button>
    </div>
  </div>

  <!-- ========================= -->
  <!-- BOLETOS -->
  <!-- ========================= -->

  <div *ngIf="list === 1" class="section boletos-section">
    <div class="boletos-header">
      <p class="section-title">Boletos</p>
      <button class="btn-back" (click)="goTo(0)">
        <mat-icon>chevron_left</mat-icon> Voltar
      </button>
    </div>

    <!-- Filtros -->


    <div class="row">
      <div *ngIf="id === 1" class="col-2 mb-3 pr-3">
        <div class="gcc-menudrop dropdown-menu" style="border: none; border-right: 1px solid #e5e5e5">
          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 1 }" (click)="goTo(1)">
              Boletos
            </a>
          </div>
          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 4 }" (click)="goTo(4)">
              Pedidos
            </a>
          </div>

          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 5 }" (click)="goTo(5)">
              Notas
            </a>
          </div>

        </div>
      </div>

      <div *ngIf="loading" class="boletos-loading">
        <div class="boletos-loading-header">
          <div class="spinner-border" role="status" aria-hidden="true"></div>
          <div class="boletos-loading-text">Buscando boletos, aguarde...</div>
        </div>
      </div>

      <div *ngIf="!loading && empty" class="empty">Nenhum boleto encontrado.</div>
      <div></div>

      <div [class]="id === 1 ? 'col-10': 'col-12'">
        <div class="boletos-card boletos-filtros-card">
          <div class="row align-items-end">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-group">
                <label i18n>Nome</label>
                <input type="text" [(ngModel)]="nome" class="form-control" />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2">
              <div class="form-group">
                <label i18n>Documento</label>
                <input type="text" class="form-control" [(ngModel)]="documento" (keypress)="allowOnlyNumbers($event)"
                  (paste)="onPaste($event)" />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 cnpj-filter">
              <div class="form-group">
                <label>CNPJ</label>
                <input type="text" class="form-control" [(ngModel)]="cnpj" (keypress)="allowOnlyNumbers($event)"
                  (paste)="onPaste($event)" />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 data-col">
              <div class="form-group">
                <label i18n>Data</label>
                <input type="text" class="form-control" bsDaterangepicker [(bsValue)]="dateRange"
                  placement="bottom left" [bsConfig]="{
                isAnimated: true,
                dateInputFormat: dateFormat,
                ranges: ranges
              }" />
              </div>
            </div>
            <div class="col-6 col-md-4 col-lg-1 cnpj-filter align-self-end">
              <div class="form-group pago-filter">
                <label>Em Aberto</label>
                <div class="pago-input">
                  <label class="switch" for="checkbox">
                    <input type="checkbox" id="checkbox" name="criaUsuario" [(ngModel)]="pago" />
                    <div class="slider round"></div>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-4 col-lg-1 align-self-end">
              <button [disabled]="loading" class="btn btn-primary w-100" type="button" (click)="getBoletos(1)">
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="loading || !empty">
          <div class="boletos-card boletos-table-card" [ngClass]="{ 'boletos-skeleton': loading }">
            <div class="table-responsive">
              <table class="table boletos-table">
                <thead>
                  <tr>
                    <th (click)="ordenar('sacadoNome')" class="sortable">
                      Sacado
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'sacadoNome'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th (click)="ordenar('sacadoCnpj')" class="sortable">
                      CNPJ
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'sacadoCnpj'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th (click)="ordenar('nossoNumero')" class="sortable">
                      Número
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'nossoNumero'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th (click)="ordenar('numeroDocumento')" class="sortable">
                      Documento
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'numeroDocumento'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th (click)="ordenar('dataEmissao')" class="sortable">
                      Emissão
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'dataEmissao'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th (click)="ordenar('dataVencimento')" class="sortable">
                      Vencimento
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'dataVencimento'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th (click)="ordenar('valorBoleto')" class="sortable text-right">
                      Valor
                      <span class="sort-icon" *ngIf="colunaOrdenada === 'valorBoleto'">
                        <mat-icon>{{ direcaoOrdenacao === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </span>
                    </th>

                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="loading; else boletosRows">
                    <tr *ngFor="let _ of skeletonRows">
                      <td>
                        <div class="skeleton-line w-60"></div>
                      </td>
                      <td>
                        <div class="skeleton-line w-40"></div>
                      </td>
                      <td>
                        <div class="skeleton-line w-30"></div>
                      </td>
                      <td>
                        <div class="skeleton-line w-40"></div>
                      </td>
                      <td>
                        <div class="skeleton-line w-30"></div>
                      </td>
                      <td>
                        <div class="skeleton-line w-30"></div>
                      </td>
                      <td class="text-right">
                        <div class="skeleton-line w-20"></div>
                      </td>
                      <td>
                        <div class="skeleton-pill"></div>
                      </td>
                    </tr>
                  </ng-container>

                  <ng-template #boletosRows>
                    <tr *ngFor="let b of boletos">
                      <td class="boleto-sacado">{{ b.sacadoNome }}</td>
                      <td>{{ b.sacadoCnpj }}</td>
                      <td>{{ b.nossoNumero }}</td>
                      <td>{{ b.numeroDocumento }}</td>
                      <td>{{ b.dataEmissao | dateBRA }}</td>
                      <td>{{ b.dataVencimento | dateBRA }}</td>
                      <td class="text-right">R$ {{ b.valorBoleto | currency : "BRL" : "" }}</td>
                      <td>
                        <button (click)="printBoletoPdf(b)" [disabled]="!pagoSearch"
                          [ngClass]="pagoSearch ? 'btn-success' : 'btn-outline-primary'"
                          [title]="pagoSearch ? 'Gerar Boleto' : 'Mostrar Boleto'" class="btn boleto-imprimir-btn">
                          Imprimir
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>

          <!-- PAGINAÇÃO SIMPLIFICADA -->
          <div class="row container-b2c" *ngIf="!loading && totalPaginas > 1">
            <!-- Info esquerda -->
            <div class="col-lg-4 pl-0 align-itens-center">
              <label i18n> Página {{ paginaAtual }} de {{ totalPaginas }} </label>
            </div>

            <!-- Controles -->
            <div class="col-lg-4 pt-0">
              <div class="pagination-custom">
                <div class="pagination-controls">
                  <!-- Primeira página -->
                  <!-- <button
                class="pagination-btn"
                [disabled]="paginaAtual === 1"
                (click)="getBoletos(1)"
                title="Primeira página"
                i18n-title
              >
                <mat-icon>keyboard_double_arrow_left</mat-icon>
              </button> -->

                  <!-- Página anterior -->
                  <button class="pagination-btn" [disabled]="paginaAtual === 1" (click)="getBoletos(paginaAtual - 1)"
                    title="Página anterior" i18n-title>
                    <mat-icon>chevron_left</mat-icon>
                  </button>

                  <!-- Texto central -->

                  <!-- <div class="pagination-custom" *ngIf="totalPaginas > 1">
                <ul class="pagination justify-content-center mb-0">
                  <li
                    class="page-item"
                    *ngFor="let i of visiblePages"
                    [class.active]="i === paginaAtual"
                  >
                    <button class="page-link" (click)="getBoletos(i)">
                      {{ i }}
                    </button>
                  </li>
                </ul>
              </div> -->
                  {{ paginaAtual }}/{{ totalPaginas }}
                  <!-- Próxima página -->
                  <button class="pagination-btn" [disabled]="paginaAtual === totalPaginas"
                    (click)="getBoletos(paginaAtual + 1)" title="Próxima página" i18n-title>
                    <mat-icon>chevron_right</mat-icon>
                  </button>

                  <!-- Última página -->
                  <!-- <button
                class="pagination-btn"
                [disabled]="paginaAtual === totalPaginas"
                (click)="getBoletos(totalPaginas)"
                title="Última página"
                i18n-title
              >
                <mat-icon>keyboard_double_arrow_right</mat-icon>
              </button> -->
                </div>
              </div>
            </div>

            <!-- Info direita -->
            <div class="col-lg-4 text-right pr-0 align-itens-center">
              <label i18n> {{ totalElements }} registros encontrados </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- ========================= -->
  <!-- ALTERAR SENHA -->
  <!-- ========================= -->

  <div *ngIf="list === 3" class="section">
    <button class="btn-back" (click)="goTo(0)">
      <mat-icon>chevron_left</mat-icon> Voltar
    </button>

    <h2>Alterar Senha</h2>

    <form (ngSubmit)="onSubmitPassword()" [formGroup]="formPassword" class="password-form mx-auto d-flex flex-row">
      <div class="mb-3 col-3">
        <label for="senhaAntiga" class="form-label">Senha antiga</label>
        <input id="senhaAntiga" class="form-control" type="password" formControlName="senhaAntiga" />
        <div *ngIf="errorPassword && formPassword.get('senhaAntiga')" class="error" i18n>
          Verifique este campo!
        </div>
      </div>

      <div class="mb-3 col-3">
        <label for="senhaNova" class="form-label">Nova senha</label>
        <input id="senhaNova" class="form-control" type="password" formControlName="senhaNova" />
        <div *ngIf="errorPassword && formPassword.get('senhaNova')" class="error" i18n>
          Verifique este campo!
        </div>
      </div>

      <div class="mb-3 col-3">
        <label for="senhaNovaConfirm" class="form-label">Confirmar nova senha</label>
        <input id="senhaNovaConfirm" class="form-control" type="password" formControlName="senhaNovaConfirm" />
        <div *ngIf="errorPassword && formPassword.get('senhaNovaConfirm')" class="error" i18n>
          Verifique este campo!
        </div>
      </div>
      <div class="mb-3 col-3 align-self-end">
        <button class="btn btn-primary" type="submit">Alterar senha</button>
      </div>
    </form>
  </div>
  <div *ngIf="list === 2" class="section">
    <button class="btn-back" (click)="goTo(0)">
      <mat-icon>chevron_left</mat-icon>
      Voltar
    </button>
    <div class="d-flex flex-row">
      <div class="section account-section col">
        <p class="section-title" i18n>Informações da sua conta</p>
        <div class="row">
          <div class="col-md-12">
            <div class="info-group">
              <label i18n>Código</label>
              <span>{{ initProvider.usuario.id }}</span>
            </div>

            <div class="info-group">
              <label i18n>Nome</label>
              <span>{{ initProvider.usuario.nome }}</span>
            </div>

            <div class="info-group">
              <label>Login</label>
              <span>{{ initProvider.usuario.login }}</span>
            </div>

            <div class="info-group">
              <label i18n>Tipo</label>
              <span>{{ initProvider.usuario.tipo }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="cliente.lenght !== 1" class="section account-section col-8">
        <novo-cliente [selectedClient]="this.cliente" [layoutB2c]="true" [registro]="true" [cadastroCliente]="true"
          [lgpdCheck]="false" [edit]="true"></novo-cliente>
      </div>
    </div>
  </div>

  <div *ngIf="list === 4" class="section">
    <!-- <button class="btn-back" (click)="goTo(0)">
      <mat-icon>chevron_left</mat-icon> Voltar
    </button>

    <p class="section-title">Pedidos ERP</p> -->

    <div class="boletos-header">
      <p class="section-title">Pedidos ERP</p>
      <button class="btn-back" (click)="goTo(0)">
        <mat-icon>chevron_left</mat-icon> Voltar
      </button>
    </div>

    <div class="row">
      <div *ngIf="id === 1" class="col-2 mb-3 pr-3">
        <div class="gcc-menudrop dropdown-menu" style="border: none; border-right: 1px solid #e5e5e5">
          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 1 }" (click)="goTo(1)">
              Boletos
            </a>
          </div>
          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 4 }" (click)="goTo(4)">
              Pedidos
            </a>
          </div>

          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 5 }" (click)="goTo(5)">
              Notas
            </a>
          </div>

        </div>
      </div>
      <div *ngIf="empty" class="empty">Nenhum pedido encontrado.</div>

      <div *ngIf="loading">Carregando...</div>
      <div [class]="id === 1 ? 'col-10': 'col-12'">
        <div class="boletos-card boletos-filtros-card">
          <div class="row align-items-end">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-group">
                <label i18n>Cliente</label>
                <input [(ngModel)]="typingCliente" [ngModelOptions]="{ standalone: true }" [typeaheadAsync]="true"
                  [typeahead]="clientes" typeaheadOptionField="{{ 'nome' }}" isAnimated="true"
                  (typeaheadOnSelect)="onSelectClientePedidos($event)"
                  (ngModelChange)="onTypingClientePedidosChange($event)"
                  (typeaheadNoResults)="typeaheadNoResultsPedidos($event)" id="cliente2" autocomplete="off"
                  class="form-control form-control-sm" />
                <!-- <input type="text" [(ngModel)]="clienteSelecionado" class="form-control" /> -->
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 data-col">
              <div class="form-group">
                <label i18n>Data</label>
                <input type="text" class="form-control" bsDaterangepicker [(bsValue)]="dateRange"
                  placement="bottom left" [bsConfig]="{
                isAnimated: true,
                dateInputFormat: dateFormat,
                ranges: ranges
              }" />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4"></div>
            <div class="col-6 col-md-4 col-lg-1 cnpj-filter align-self-end">
              <div class="form-group pago-filter">
                <label>Em Aberto</label>
                <div class="pago-input">
                  <label class="switch" for="checkbox">
                    <input type="checkbox" id="checkbox" name="criaUsuario" [(ngModel)]="pago" />
                    <div class="slider round"></div>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-4 col-lg-1 align-self-end">
              <button [disabled]="loading" class="btn btn-primary w-100" type="button" (click)="getPedidoErp()">
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div class="boletos-card boletos-table-card" *ngIf="!empty && !loading">
          <div class="table-responsive ">
            <table class="table boletos-table">
              <thead>
                <tr>
                  <!-- <th scope="col" i18n>Status</th> -->
                  <th scope="col" i18n>Data de emissão</th>
                  <th scope="col" i18n>Cliente</th>
                  <th scope="col" i18n>Número pedido</th>
                  <!-- <th scope="col" i18n>Pedido</th> -->
                  <th scope="col" i18n>Qtd</th>
                  <th scope="col" i18n>Valor</th>
                  <th scope="col" i18n>Qtd entregue</th>
                  <th scope="col" i18n>Valor entregue</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of pedidosCliente">
                  <td>
                    {{
                    b.data_emissao.slice(-2) +
                    "/" +
                    b.data_emissao.slice(5, 7) +
                    "/" +
                    b.data_emissao.slice(0, 4)
                    }}
                  </td>
                  <td>{{ b.cliente_iderp }}</td>
                  <td>{{ b.numero_pedido }}</td>
                  <!-- <td>{{ b.pedido_id}}</td> -->
                  <td>{{ b.quantidade }}</td>
                  <td>{{ b.valor_pedido | currency : "BRL" }}</td>
                  <td>{{ b.quantidade_entregue }}</td>
                  <td>{{ b.valor_entregue | currency : "BRL" }}</td>
                  <td>
                    <div class="row">
                      <!-- <button
                              (click)="redirectToRastreio(b)"
                              class="btn btn-outline-primary mr-1 rastreio-btn"
                              title="Rastreio"
                              i18n-title
                            >
                              <mat-icon>local_shipping</mat-icon>
                            </button> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- PAGINAÇÃO SIMPLIFICADA -->
          <div class="row container-b2c" *ngIf="totalPaginas > 1">
            <!-- Info esquerda -->
            <div class="col-lg-4 pl-0 align-itens-center">
              <label i18n> Página {{ paginaAtual }} de {{ totalPaginas }} </label>
            </div>

            <!-- Controles -->
            <div class="col-lg-4 pt-0">
              <div class="pagination-custom">
                <div class="pagination-controls">
                  <!-- Primeira página -->
                  <!-- <button
                class="pagination-btn"
                [disabled]="paginaAtual === 1"
                (click)="getBoletos(1)"
                title="Primeira página"
                i18n-title
              >
                <mat-icon>keyboard_double_arrow_left</mat-icon>
              </button> -->

                  <!-- Página anterior -->
                  <button class="pagination-btn" [disabled]="paginaAtual === 1" (click)="getBoletos(paginaAtual - 1)"
                    title="Página anterior" i18n-title>
                    <mat-icon>chevron_left</mat-icon>
                  </button>

                  <!-- Texto central -->

                  <!-- <div class="pagination-custom" *ngIf="totalPaginas > 1">
                <ul class="pagination justify-content-center mb-0">
                  <li
                    class="page-item"
                    *ngFor="let i of visiblePages"
                    [class.active]="i === paginaAtual"
                  >
                    <button class="page-link" (click)="getBoletos(i)">
                      {{ i }}
                    </button>
                  </li>
                </ul>
              </div> -->
                  {{ paginaAtual }}/{{ totalPaginas }}
                  <!-- Próxima página -->
                  <button class="pagination-btn" [disabled]="paginaAtual === totalPaginas"
                    (click)="getBoletos(paginaAtual + 1)" title="Próxima página" i18n-title>
                    <mat-icon>chevron_right</mat-icon>
                  </button>

                  <!-- Última página -->
                  <!-- <button
                class="pagination-btn"
                [disabled]="paginaAtual === totalPaginas"
                (click)="getBoletos(totalPaginas)"
                title="Última página"
                i18n-title
              >
                <mat-icon>keyboard_double_arrow_right</mat-icon>
              </button> -->
                </div>
              </div>
            </div>

            <!-- Info direita -->
            <div class="col-lg-4 text-right pr-0 align-itens-center">
              <label i18n> {{ totalElements }} registros encontrados </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="list === 5" class="section">

    <div class="boletos-header">
      <p class="section-title">Notas</p>
      <button class="btn-back" (click)="goTo(0)">
        <mat-icon>chevron_left</mat-icon> Voltar
      </button>
    </div>



    <div class="row">
      <div *ngIf="id === 1" class="col-2 mb-3 pr-3">
        <div class="gcc-menudrop dropdown-menu" style="border: none; border-right: 1px solid #e5e5e5">
          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 1 }" (click)="goTo(1)">
              Boletos
            </a>
          </div>
          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 4 }" (click)="goTo(4)">
              Pedidos
            </a>
          </div>

          <div>
            <a class="dropdown-item anchor-select" [ngClass]="{ 'anchor-selected': +list === 5 }" (click)="goTo(5)">
              Notas
            </a>
          </div>

        </div>
      </div>

      <div *ngIf="empty" class="empty">Nenhum boleto encontrado.</div>

      <div [class]="id === 1 ? 'col-10': 'col-12'" *ngIf="loading">Carregando...</div>
      <div [class]="id === 1 ? 'col-10': 'col-12'">
        <div class="boletos-card boletos-filtros-card">
          <div class="row align-items-end">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="form-group">
                <label i18n>Cliente</label>
                <input [(ngModel)]="typingCliente" [ngModelOptions]="{ standalone: true }" [typeaheadAsync]="true"
                  [typeahead]="clientes" typeaheadOptionField="{{ 'nome' }}" isAnimated="true"
                  (typeaheadOnSelect)="onSelectClientePedidos($event)"
                  (ngModelChange)="onTypingClientePedidosChange($event)"
                  (typeaheadNoResults)="typeaheadNoResultsPedidos($event)" id="cliente2" autocomplete="off"
                  class="form-control form-control-sm" />
                <!-- <input type="text" [(ngModel)]="clienteSelecionado" class="form-control" /> -->
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 data-col">
              <div class="form-group">
                <label i18n>Data</label>
                <input type="text" class="form-control" bsDaterangepicker [(bsValue)]="dateRange"
                  placement="bottom left" [bsConfig]="{
                isAnimated: true,
                dateInputFormat: dateFormat,
                ranges: ranges
              }" />
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4"></div>
            <div class="col-6 col-md-4 col-lg-1 cnpj-filter align-self-end">
              <!-- <div class="form-group pago-filter">
                <label>Em Aberto</label>
                <div class="pago-input">
                  <label class="switch" for="checkbox">
                    <input type="checkbox" id="checkbox" name="criaUsuario" [(ngModel)]="pago" />
                    <div class="slider round"></div>
                  </label>
                </div>
              </div> -->
            </div>
            <div class="col-6 col-md-4 col-lg-1 align-self-end">
              <button [disabled]="loading" class="btn btn-primary w-100" type="button" (click)="getPedidoNotas()">
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div class="boletos-card boletos-table-card" *ngIf="!empty && !loading">

          <div class="table-responsive ">
            <table class="table boletos-table">
              <thead>
                <tr>
                  <th scope="col" i18n>Data de emissão</th>
                  <th scope="col" i18n>Nota</th>
                  <th scope="col" i18n>Série</th>
                  <!-- <th scope="col" i18n>Cliente</th> -->
                  <th scope="col" i18n>Chave</th>
                  <th scope="col" i18n>Status</th>
                  <th scope="col" i18n>Quantidade</th>
                  <th scope="col" i18n>Valor produtos</th>
                  <th scope="col" i18n>Valor</th>
                  <th scope="col" i18n></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of notasPedido">
                  <td>{{ b.data_emissao_nf | date : "dd-MM-yyyy" }}</td>
                  <td>{{ b.nota }}</td>
                  <td>{{ b.serie }}</td>
                  <!-- <td>{{ b.cliente }}</td> -->
                  <td>{{ b.chave_nfe }}</td>
                  <td>{{ b.status }}</td>
                  <td>{{ b.quantidade }}</td>
                  <td>{{ b.valor_produtos | currency : "BRL" }}</td>
                  <td>{{ b.valor_nota | currency : "BRL" }}</td>
                  <td>
                    <div *ngIf="
                              b.documentos && b.documentos.length > 1;
                              else elseBlockPrint1
                            " class="dropdown nfe-btn">
                      <button class="btn btn-outline-primary dropdown-toggle buttonMiddle"
                        style="min-height: -webkit-fill-available" id="dropdownMenuLink" data-toggle="dropdown"
                        title="Nota fiscal" i18n-title>
                        <img src="assets/nfe-icon.svg" class="normal-icon" width="24" />
                        <img src="assets/nfe-icon-hover.svg" class="hover-icon" width="24" />
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" style="cursor: pointer">
                        <a *ngFor="let p of b.documentos" (click)="printNota(p)" class="dropdown-item">
                          {{ p.link}}
                        </a>
                      </div>
                    </div>
                    <ng-template #elseBlockPrint1>
                      <button
                      *ngIf="b.documentos.length === 1"
                              class="btn btn-outline-primary buttonMiddle nfe-btn"
                              title="Nota fiscal"
                              i18n-title
                              [class.spinner]="loadNota"
                              [disabled]="!b.documentos || loadNota"
                              (click)="printNota(b.documentos[0])"
                            >
                              <img
                                src="assets/nfe-icon.svg"
                                class="normal-icon"
                                width="24"
                              />
                              <img
                                src="assets/nfe-icon-hover.svg"
                                class="hover-icon"
                                width="24"
                              />
                            </button>
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- PAGINAÇÃO SIMPLIFICADA -->
          <div class="row container-b2c" *ngIf="totalPaginas > 1">
            <!-- Info esquerda -->
            <div class="col-lg-4 pl-0 align-itens-center">
              <label i18n> Página {{ paginaAtual }} de {{ totalPaginas }} </label>
            </div>

            <!-- Controles -->
            <div class="col-lg-4 pt-0">
              <div class="pagination-custom">
                <div class="pagination-controls">
                  <!-- Primeira página -->
                  <!-- <button
                class="pagination-btn"
                [disabled]="paginaAtual === 1"
                (click)="getBoletos(1)"
                title="Primeira página"
                i18n-title
              >
                <mat-icon>keyboard_double_arrow_left</mat-icon>
              </button> -->

                  <!-- Página anterior -->
                  <button class="pagination-btn" [disabled]="paginaAtual === 1" (click)="getBoletos(paginaAtual - 1)"
                    title="Página anterior" i18n-title>
                    <mat-icon>chevron_left</mat-icon>
                  </button>

                  <!-- Texto central -->

                  <!-- <div class="pagination-custom" *ngIf="totalPaginas > 1">
                <ul class="pagination justify-content-center mb-0">
                  <li
                    class="page-item"
                    *ngFor="let i of visiblePages"
                    [class.active]="i === paginaAtual"
                  >
                    <button class="page-link" (click)="getBoletos(i)">
                      {{ i }}
                    </button>
                  </li>
                </ul>
              </div> -->
                  {{ paginaAtual }}/{{ totalPaginas }}
                  <!-- Próxima página -->
                  <button class="pagination-btn" [disabled]="paginaAtual === totalPaginas"
                    (click)="getBoletos(paginaAtual + 1)" title="Próxima página" i18n-title>
                    <mat-icon>chevron_right</mat-icon>
                  </button>

                  <!-- Última página -->
                  <!-- <button
                class="pagination-btn"
                [disabled]="paginaAtual === totalPaginas"
                (click)="getBoletos(totalPaginas)"
                title="Última página"
                i18n-title
              >
                <mat-icon>keyboard_double_arrow_right</mat-icon>
              </button> -->
                </div>
              </div>
            </div>

            <!-- Info direita -->
            <div class="col-lg-4 text-right pr-0 align-itens-center">
              <label i18n> {{ totalElements }} registros encontrados </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>